import React, { useRef } from 'react'
import "./Contact.css"
import { Steps } from 'rsuite'
import { ImLocation } from 'react-icons/im'
import { MdEmail, MdCall } from 'react-icons/md'
import emailjs from '@emailjs/browser'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import {
    SiNextdotjs, SiExpress, SiJavascript, SiTypescript, SiGithub, SiSass, SiCss3, SiHtml5, SiLinkedin, SiFacebook, SiTwitter, SiGmail,
    SiBootstrap, SiTailwindcss, SiHeroku, SiFirebase, SiNetlify,
}
    from 'react-icons/si'



const Contact = () => {
    const form = useRef()
    const notify = () => toast("Thank You For Contact Me ")

    const handleFormSubmit = (event) => {
        event.preventDefault()

        emailjs.sendForm('service_cns8tpm', 'template_fszc5oj', form.current, 'TxwQ895uVKQmBOcFr')
            .then((result) => {
                console.log(result.text)
            }, (error) => {
                console.log(error.text)
            })

        event.target.name.value = ""
        event.target.email.value = ""
        event.target.number.value = ""
        event.target.message.value = ""
    }


    return (
        <div id='contactsid' className='pb-5 pt-3'>
            <div>
                <h3 className='text-center react_icon'>Contact Me -</h3>
            </div>
            <div className='text-center text-white mt-5'>
                <h4>Get In Touch</h4>
                <p>I am available to work on your projects and bring your ideas to life. I am just a click away.</p>
            </div>
            <div className=' text-white row m-0 p-0'>
                <div className="col-lg-2"></div>
                <div className="col-lg-4">
                    <div className='d-flex fw-bold  align-items-center my-4 '>
                        <div>
                            <ImLocation className='icon'></ImLocation>
                        </div>
                        <span className='ms-3'>Raozan, Chittagong</span>
                    </div>
                    <div className='d-flex  fw-bold  align-items-center my-4'>
                        <div>
                            <MdEmail className='icon '></MdEmail>
                        </div>
                        <span className='ms-3'>omarfaruk.dep@gmail.com</span>
                    </div>
                    <div className='d-flex  fw-bold  align-items-center my-4'>
                        <div>
                            <MdCall className='icon'></MdCall>
                        </div>
                        <span className='ms-3'>01402-453207</span>
                    </div>
                </div>
                <div className="col-lg-6">


                    <form ref={form} onSubmit={handleFormSubmit} >
                        <input className='nameInput  mx-auto inputFrom' placeholder='Your Full Name' type="text" name="name" id="" required />
                        <div className='mt-3'>
                            <div className=' emailInput' >
                                <input className=' inputFrom ' placeholder='Your Email' type="email" name="email" id="" required />
                            </div>
                            <div className='numberInput  mt-2'>
                                <input className=' inputFrom' placeholder='Your Number' type="number" name="number" id="" required />
                            </div>
                        </div>
                        <div>
                            <textarea className='text my-3 ' placeholder='Enter Your Message' name='message' required></textarea>
                        </div>
                        <input onClick={notify} className='submit' type="submit" value="Submit" />
                        <ToastContainer />

                    </form>
                </div>
            </div>
            {/* Icon section for social */}


            <div className='text-white my-5 d-flex align-items-center justify-content-center'>

                {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis, voluptatibus!</p> <br /> */}
                <div className="react_icon">
                    <a href="https://github.com/Omarfaruk2" target="_blank" rel="noopener noreferrer"> <SiGithub ></SiGithub></a>
                </div>
                <hr className='social-hr' />

                {/* linkin */}
                <div className="react_icon">
                    <a href="https://www.linkedin.com/in/mahammad-omar-faruk-emon-167044231/" target="_blank" rel="noopener noreferrer"> <SiLinkedin></SiLinkedin></a>
                </div>
                <hr className='social-hr' />

                {/* facebook */}
                <div className="react_icon">
                    <a href="https://web.facebook.com/Omarfarukhshsu22" target="_blank" rel="noopener noreferrer">   <SiFacebook></SiFacebook></a>
                </div>
                <hr className='social-hr' />

                {/* SiTwitter */}
                <div className="react_icon">
                    <a href="https://twitter.com/omarfaruk404" target="_blank" rel="noopener noreferrer">       <SiTwitter></SiTwitter></a>

                </div>
                <hr className='social-hr' />

                {/* SiGmail */}
                <div className="react_icon">
                    <a href="emon35293@gmail.com" target="_blank" rel="noopener noreferrer">     <SiGmail></SiGmail></a>

                </div>
                {/* <hr className='social-hr' /> */}



            </div>
        </div>
    )
}

export default Contact